(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("HJPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["HJPlayer"] = factory();
	else
		root["HJPlayer"] = factory();
})(this, function() {
return 